import { useEffect } from 'react'
import Auth from '@aws-amplify/auth'
import { useNavigate, useLocation } from 'react-router'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import CssBaseline from '@mui/material/CssBaseline'
import { styled } from '@mui/material/styles'
import { useAuth } from '../context/auth'
import { GoogleSignInButton, SignOutButton } from '../components/SignIn'
import { Loading } from '../components/Loading'
import Copyright from '../components/Copyright'

const ButtonContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(8),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}))

export default function SignIn() {
  const { isAuthenticated, loading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const { from } = location?.state || { from: { pathname: '/' } }
  console.debug(`Login: from = `, from)

  useEffect(() => {
    if (isAuthenticated) {
      console.debug('Login:useEffect', location)
      const origin = from?.pathname || '/'
      navigate(origin)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from, navigate, isAuthenticated, loading])

  const handleLogin = () => {
    console.debug('Login: Starting federatedSignIn')
    Auth.federatedSignIn({ provider: 'Google' })
  }

  if (loading) return <Loading />

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <ButtonContainer>{isAuthenticated ? <SignOutButton /> : <GoogleSignInButton onClick={handleLogin} />}</ButtonContainer>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  )
}
